<template>
  <div>
    <v-container grid-list-xl fluid>
      <header-title title="Consulta de resultado oficial de la Prueba Académica de selección de postulantes a becas sociales."></header-title>
      <div v-if="convocatoria.id > 0">
        <v-row>
          <v-col cols="12">
            <v-card>
              <v-card-text>
                <!-- <p class="subtitle-1 font-weight-bold">
                  {{ convocatoria.cite }}
                </p> -->
                <p>
                  Ingrese su
                  <b>cédula de identidad, complemento y fecha de nacimiento</b>
                </p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row class="mb-1">
          <v-col cols="12">
            <v-card>
              <v-card-text>
                <v-form ref="formp" @submit.prevent="searchPostulante()">
                  <v-row>
                    <v-col cols="12" sm="3">
                      <v-text-field
                        v-model="postulante.a_postulante.a_persona.cedula_dni"
                        label="Cédula de identidad"
                        :rules="[
                          (v) => !!v || 'El campo es requerido',
                          (v) => (!!v && v.length > 3) || 'Mínimo 4 dígitos',
                        ]"
                        hint="1234567"
                        clearable
                        filled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="1">
                      <v-text-field v-model.trim="postulante.a_postulante.a_persona.complemento" maxlength="2" label="Complemento" :rules="[
                      ]" hint="1G" clearable filled></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-menu
                        v-model="menu_date"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="birthDateFormatted"
                            label="Fecha de nacimiento"
                            append-icon="mdi-calendar"
                            :rules="[(v) => !!v || 'El campo es requerido']"
                            filled
                            readonly
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="
                            postulante.a_postulante.a_persona.fecha_nacimiento
                          "
                          @input="menu_date = false"
                          locale="es"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" sm="5">
                      <v-btn
                        type="submit"
                        large
                        color="primary"
                        :loading="load_search"
                      >
                        <v-icon>mdi-magnify</v-icon>
                        Buscar
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
                <div v-if="type_state == 3">
                  <v-row>
                    <v-col cols="8" class="pt-0">
                      <h4 class="grey--text">DATOS PERSONALES</h4>
                      <v-row>

                        <v-col cols="6" class="pt-0">
                          <v-list-item two-line>
                            <v-list-item-content>
                              <v-list-item-title><b>Apellidos y Nombres:</b></v-list-item-title
                              >
                              <v-list-item-subtitle>
                              </v-list-item-subtitle>
                              <v-list-item-body>
                                {{ postulante_data.nombres}} {{ postulante_data.paterno}} {{ postulante_data.materno}}
                              </v-list-item-body>
                            </v-list-item-content>
                          </v-list-item>
                        </v-col>
                        <!-- <v-col cols="6" sm="4" class="pt-0">
                          <v-list-item two-line>
                            <v-list-item-content>
                              <v-list-item-title><b>Sede:</b></v-list-item-title>
                              <v-list-item-subtitle>
                              </v-list-item-subtitle>
                              <v-list-item-body>
                                {{ postulante.sede.nombre }}
                              </v-list-item-body>
                            </v-list-item-content>
                          </v-list-item>
                        </v-col> -->
                      </v-row>
  <!--                       
  <h4 class="grey--text mt-5">DATOS DE POSTULACIÓN</h4>
                        <v-row>
                          <v-col cols="6" class="pt-0">
                            <v-list-item two-line>
                              <v-list-item-content>
                                <v-list-item-title><b>INSTITUTO:</b></v-list-item-title>
                                <v-list-item-subtitle>
                                </v-list-item-subtitle>
                                <v-list-item-body>
                                  {{ postulante_data.departamento }}-{{ postulante_data.universidad_nombre }}
                                </v-list-item-body>
                              </v-list-item-content>
                            </v-list-item>
                          </v-col>
                          <v-col cols="6" sm="4" class="pt-0">
                            <v-list-item two-line>
                              <v-list-item-content>
                                <v-list-item-title><b>CARRERA:</b></v-list-item-title>
                                <v-list-item-subtitle>
                                </v-list-item-subtitle>
                                <v-list-item-body>
                                  {{ postulante_data.especialidad_descripcion }}
                                </v-list-item-body>
                              </v-list-item-content>
                            </v-list-item>
                          </v-col>

                          </v-row> -->
                         <v-row>
                          <v-col cols="12"  class="pt-0">
                          
                                <h2 class="grey--text mt-5">
                                    <p>
                                    Las notas obtenidas tienen carácter estrictamente informativo y no reflejan la elección del postulante. En caso de empate,
                                    la definición de la seleción se realizará conforme al Artículo 17 del Reglamento la Convocatoria, según las plazas disponibles.
                                  </p>
                                  </h2> 
                        </v-col>
                           
                        </v-row>
                        </v-col>
                        <v-col cols="4" class="pt-0">
                          <v-row>
                            <v-col cols="12" class="pt-0" >
                              <v-list-item two-line>
                                <v-list-item-content>
                                  <v-list-item-title>NOTA EXÁMEN</v-list-item-title>
                                  <v-list-item-subtitle style="font-size: 25px !important;color: #ff0000;" v-if="sin_cero">
                                    <img :src="`data:image/png;base64,${notaImagen}`" :alt="postulante_data.resultado" style="max-width: 100%; height: auto;" />
                                  </v-list-item-subtitle>
                                  <v-list-item-subtitle style="font-size: 25px !important;color: #ff0000;" v-else class="text-wrap">

                                      Su prueba presenta observaciones. Para mayor información, comuníquese con el Centro de Contactos del Ministerio de Educación. 71550970 - 71530671 - 78864958
                                    
                                    <!-- <h3 class="grey--text mt-5">
                                    </h3>  -->
                                  </v-list-item-subtitle>
                                  
                                </v-list-item-content>
                              </v-list-item>
                            </v-col>
                          </v-row>
                        </v-col>
                       
                      </v-row>
                    
                    
                 
                 
                  
<!--                 
                  <a color="#546E7A" target="_blank" download style="font-size: 25px !important"
                    outlined :href="'//dgfmapi.minedu.gob.bo/admision/admitidos/'+ postulante.institucion.id +'.pdf'" >LISTA  OFICIAL  DE ADMITIDOS ESFM UA</a> -->
                </div>
                <div v-if="type_state === 4">
                  <span class="red--text">
                    
                    No se encontro calificación con los datos de: 
                    <b>Cédula de Identidad y Fecha de Nacimiento</b>
                    ingresada.
                  </span>

                </div>
                <div v-if="type_state === 2">
                  <span class="red--text">
                    {{ message }} <br>
                  </span>

                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>
      <div v-else>
        <notify-card
          :title="notify_title"
          :load="notify_load"
          process="el proceso de admisión"
        ></notify-card>
      </div>
    </v-container>
  </div>
</template>

<script>
import HeaderTitle from "@/components/HeaderTitle";
import NotifyCard from "@/components/NotifyCard";
import Service from "../services/request";
import { mapActions } from "vuex";

const { createCanvas } = require('canvas');

export default {
  name: "admision-consultar-butaca",
  components: {
    HeaderTitle,
    NotifyCard,
  },
  data: () => ({
    notify_title: "Cargando",
    notify_load: true,
    load_search: false,
    menu_date: false,
    type_state: 1,
    convocatoria: {
      id: 0,
      cite: "",
      descripcion: "",
      gestion: "",
    },
    postulante_data:{
      
      nombres:"", 
      paterno:"", 
      materno:"", 
      cedula_dni:"", 
      fecha_nacimiento:"",
      complemento:"", 
      sede_nombre:"", 
      universidad_nombre:"",
      especialidad_descripcion:"",
    },

    postulante: {
      resultado:"", 

      id:"",
      butaca: "",
      nota_aptitud: "",
      porcentaje_aptitud: "",
      nota_escrita: "",
      porcentaje_escrita: "",
      observacion: "",
      filtro: "",
      a_postulante: {
        id:"",
        estado_id: "",
        a_persona: {
          nombre_completo: "",
          nombres: "",
          paterno: "",
          materno: "",
          cedula_dni: "",
          fecha_nacimiento: "",
          complemento:"",
          genero: {},
        },
      },
      institucion: {},
      especialidad: {},
      sede: {},
    },
    admitidos:{

    },
    notaImagen: "",
    sin_cero: false,
  }),
  computed: {
    birthDateFormatted() {
      if (!this.postulante.a_postulante.a_persona.fecha_nacimiento) return null;

      const [year, month, day] =
        this.postulante.a_postulante.a_persona.fecha_nacimiento.split("-");
      return `${day}/${month}/${year}`;
    },
  },
  created() {
    this.getAnnouncement();
  },
  methods: {
    ...mapActions(["toast"]),
    getAnnouncement() {
      this.notify_load = true;
      Service.svcAdmissionAnnouncement()
        .then((response) => {
          this.convocatoria = response.data;
          this.notify_title = "Notificación";
          this.notify_load = false;

        })
        .catch(() => {
          this.notify_title = "Notificación";
          this.notify_load = false;
        });
    },
    searchPostulante() {
      /* this.postulante = {
        a_postulante: {
          id: "",
          persona: {
            cedula_dni: "",
            paterno: "",
            materno: "",
            nombres: "",
            nombre_completo: "",
            fecha_nacimiento: "",
          },
        },
        institucion: {},
        especialidad: {},
        butaca: "",
        id: "",
      }; */
      this.postulante.a_postulante.a_persona.nombre_completo = "";
      this.postulante.a_postulante.a_persona.genero = {};
      // this.postulante.a_postulante.persona.cedula_dni = "";
      this.postulante.butaca = "";
      this.postulante.institucion.institucion = {};
      this.postulante.institucion = {};
      this.postulante.especialidad = {};
      this.postulante.nota_aptitud = "-";
      this.postulante.nota_escrita = "-";
      this.postulante.porcentaje_aptitud = "-";
      this.postulante.porcentaje_escrita = "-";
      this.postulante.resultado = "-";
      this.postulante.filtro = "";
      if (this.$refs.formp.validate()) {
        this.load_search = true;
        this.type_state = 1;
        Service.svcCheckResult({
          convocatoria_id: this.convocatoria.id,
          cedula_dni: this.postulante.a_postulante.a_persona.cedula_dni,
          fecha_nacimiento: this.postulante.a_postulante.a_persona.fecha_nacimiento,
          complemento : this.postulante.a_postulante.a_persona.complemento,
        })
          .then(async(response) => {
            this.load_search = false;
            if (response.status == 200) {
              this.postulante_data = response.data[0];
              if(this.postulante_data.resultado != 0){
                this.notaImagen = this.convertirImagenBase64(this.postulante_data.resultado, this.postulante_data.cedula_dni);
                this.sin_cero = true;
              }else{
                this.sin_cero = false;
              }
              this.type_state = 3;
            } else {
              this.type_state = 2;
              // this.message = response.data.message;
            }
            
          })
          .catch(() => {
            console.log("error");
            this.load_search = false;
            this.type_state = 4;
          });



          
      } else {
        this.type_state = 1;
        this.toast({
          color: "info",
          text: "Ingrese Cédula de identidad y Fecha de nacimiento",
        });
      }
    },
    convertirImagenBase64(numero,nombre){
      // Crear canvas y
      let tamañoImagen = 800
      let tamañoFuente = 400
      const canvas = createCanvas(tamañoImagen, tamañoImagen);
      const ctx = canvas.getContext('2d');
      
      // Llenar fondo blanco
      ctx.fillStyle = 'white';
      ctx.fillRect(0, 0, tamañoImagen, tamañoImagen);
      
      // Convertir número a string
      const numeroStr = String(numero);
      
      // Configurar fuente para el número
      ctx.font = `bold ${tamañoFuente}px Sans`;
      ctx.fillStyle = 'black';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      
      
      const x = tamañoImagen / 2;
      const y = tamañoImagen / 2;
      
      // Dibujar el número con relleno blanco y contorno negro
      ctx.fillStyle = 'white';
      ctx.fillText(numeroStr, x, y);
      ctx.lineWidth = 3;
      ctx.strokeStyle = 'black';
      ctx.strokeText(numeroStr, x, y);
      
      // Usar clipping para que solo se dibuje dentro del número
      ctx.save();
      ctx.beginPath();
      
      // Crear path del texto para usarlo como máscara de recorte
      // Primero, necesitamos crear el número de nuevo pero en modo de path
      ctx.font = `bold ${tamañoFuente}px Sans`;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      
      // Usar fillText como path para definir el área de recorte
      // Dibujamos un rectángulo blanco completo primero
      ctx.clearRect(0, 0, tamañoImagen, tamañoImagen);
      ctx.fillStyle = 'white';
      ctx.fillRect(0, 0, tamañoImagen, tamañoImagen);
      
      // Crear canvas para la máscara
      const canvasMascara = createCanvas(tamañoImagen, tamañoImagen);
      const ctxMascara = canvasMascara.getContext('2d');
      
      // Dibujar el número en la máscara en blanco
      ctxMascara.fillStyle = 'white';
      ctxMascara.fillRect(0, 0, tamañoImagen, tamañoImagen);
      ctxMascara.font = `bold ${tamañoFuente}px Sans`;
      ctxMascara.fillStyle = 'black';
      ctxMascara.textAlign = 'center';
      ctxMascara.textBaseline = 'middle';
      ctxMascara.fillText(numeroStr, x, y);
      ctxMascara.strokeStyle = 'black';
      ctxMascara.lineWidth = 3;
      ctxMascara.strokeText(numeroStr, x, y);
      
      // Obtener datos de píxeles de la máscara
      const mascara = ctxMascara.getImageData(0, 0, tamañoImagen, tamañoImagen);
      const dataMascara = mascara.data;
      
      // Dibujar el texto repetido en el canvas principal
      ctx.font = '20px Sans';
      ctx.fillStyle = '#780b17';
      
      let xTexto = 0;
      let yTexto = 0;
      const espaciado = 25;
      
      while (yTexto < tamañoImagen) {
        ctx.fillText(nombre, xTexto, yTexto);
        xTexto += nombre.length * 8;
          if (xTexto > tamañoImagen) {
            xTexto = 0;
            yTexto += espaciado;
          }
        }
        
        // Obtener datos de píxeles del canvas principal
        const imagenConTexto = ctx.getImageData(0, 0, tamañoImagen, tamañoImagen);
        const dataImagen = imagenConTexto.data;
        
        // Aplicar la máscara: mantener píxeles donde la máscara sea negra (número)
        for (let i = 0; i < dataMascara.length; i += 4) {
          // Si en la máscara no es negro (es decir, no es parte del número), hacer transparente
          if (dataMascara[i] === 255 && dataMascara[i + 1] === 255 && dataMascara[i + 2] === 255) {
            // No es parte del número, restaurar fondo blanco
            dataImagen[i] = 255;
            dataImagen[i + 1] = 255;
            dataImagen[i + 2] = 255;
          }
        }
        
      // Dibujar el número con contorno negro encima
      ctx.font = `bold ${tamañoFuente}px Sans`;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.putImageData(imagenConTexto, 0, 0);
      ctx.lineWidth = 3;
      ctx.strokeStyle = 'black';
      ctx.strokeText(numeroStr, x, y);
      
      ctx.restore();
      
      // Encontrar los límites del número para recortar espacio en blanco
      const imageData = ctx.getImageData(0, 0, tamañoImagen, tamañoImagen);
      const data = imageData.data;
      
      let minX = tamañoImagen, maxX = 0, minY = tamañoImagen, maxY = 0;
      
      // Buscar los límites de píxeles no blancos
      for (let i = 0; i < data.length; i += 4) {
        // Si no es blanco (píxeles del número)
        if (!(data[i] === 255 && data[i + 1] === 255 && data[i + 2] === 255)) {
          const posicion = i / 4;
          const y = Math.floor(posicion / tamañoImagen);
          const x = posicion % tamañoImagen;
          
          if (x < minX) minX = x;
          if (x > maxX) maxX = x;
          if (y < minY) minY = y;
          if (y > maxY) maxY = y;
        }
      }
      
      // Agregar un pequeño margen
      const margen = 10;
      minX = Math.max(0, minX - margen);
      minY = Math.max(0, minY - margen);
      maxX = Math.min(tamañoImagen, maxX + margen);
      maxY = Math.min(tamañoImagen, maxY + margen);
      
      const anchox = maxX - minX;
      const altox = maxY - minY;
      
      // Crear nuevo canvas recortado
      const canvasRecortado = createCanvas(anchox, altox);
      const ctxRecortado = canvasRecortado.getContext('2d');
      
      // Copiar la región recortada
      const imagenRecortada = ctx.getImageData(minX, minY, anchox, altox);
      ctxRecortado.putImageData(imagenRecortada, 0, 0);
      
      // Convertir canvas recortado a base64
      const dataUrl = canvasRecortado.toDataURL('image/png');
      const base64 = dataUrl.split(',')[1];
      
      // Asegurar que retorna un string válido
      return base64 || '';

  }






  },
};
</script>
<style scoped>
table thead th {
  background-color: #e0e0e0;
}
table,
th,
td {
  border: 1px solid #bdbdbd;
  border-collapse: collapse;
}
</style>